var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDubai = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00732F",
    d: "M1.758 0H30.242C31.374 0 32 0.626 32 1.758v28.484c0 1.132-0.626 1.758-1.758 1.758H1.758C0.626 32 0 31.374 0 30.242V1.758C0 0.626 0.626 0 1.758 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32 10.726H0V30.242c0 1.132 0.626 1.758 1.758 1.758H30.242c1.132 0 1.758-0.626 1.758-1.758V10.726z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 20.454H0v9.586c0 1.132 0.626 1.758 1.758 1.758H30.242c1.132 0 1.758-0.626 1.758-1.758v-9.586z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M8.871 32V0H1.758C0.626 0 0 0.626 0 1.758v28.484C0 31.374 0.626 32 1.758 32h7.113z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDubai);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Dubai.fe6cfe667d31bfa3428f8c498d70a2f0.svg";